/* eslint-env browser */
/* globals Backbone */

'use strict';

const DiscountView = Backbone.View.extend({
  el: '#discount-data, .discount-data',

  initialize() {
    return window.DealEventPipe.on('priceUpdate', priceData =>
      this.updateTiles(priceData)
    );
  },

  updateTiles({ value, percent, savings, hideOriginalPriceAndDiscount }) {
    this.$('#discount-value, .discount-value').html(value);
    this.$('#discount-percent, .discount-percent').html(percent);
    this.$('#discount-you-save, .discount-you-save').html(savings);
    if (hideOriginalPriceAndDiscount) {
      return this.$el.parents('.deal-discount').hide();
    } else {
      return this.$el.parents('.deal-discount').show();
    }
  },
});

module.exports = DiscountView;
